import {Component} from '@angular/core';
import {OptionsTypeList} from '../../../../../common/enums/options-type-list';
import {NavParams, Platform} from '@ionic/angular';
import {from} from 'rxjs';
import {Device} from '@capacitor/device';
import {map} from 'rxjs/operators';
import {environment} from '../../../../../../environments/environment';

interface VideoModel {
  name: string;
  url: string;
  isLoaded: boolean;
  poster: string;
}

@Component({
  selector: 'app-options-how-it-works-modal',
  templateUrl: './options-how-it-works-modal.component.html',
  styleUrls: ['./options-how-it-works-modal.component.scss'],
})
export class OptionsHowItWorksModalComponent {
  url = environment.fydlApi.url;
  isItIos: boolean;
  isItAndroid: boolean;
  optionsTypeList = OptionsTypeList;
  currentOption: OptionsTypeList;
  devicePlatformInfo$ = from(Device.getInfo()).pipe(map(info => info.platform));
  private videos: VideoModel [] = [
    {
      name: 'fydl-reward-add',
      url: this.url + '/assets/videos/reward/fydl-reward-add.mp4',
      poster: 'assets/options-how-it-work-illustration/rewards/posters/reward-add-poster.webp',
      isLoaded: false
    },
    {
      name: 'fydl-reward-unlocking',
      url: this.url + '/assets/videos/reward/fydl-reward-unlocking.mp4',
      poster: 'assets/options-how-it-work-illustration/rewards/posters/reward-unlocking-poster.webp',
      isLoaded: false
    },
    {
      name: 'fydl-NFC-android',
      url: this.url + '/assets/videos/tag/fydl-NFC-android.mp4',
      poster: 'assets/qr-code-page-images/nfc-android.webp',
      isLoaded: false
    },
    {
      name: 'fydl-NFC-ios',
      url: this.url + '/assets/videos/tag/fydl-NFC-ios.mp4',
      poster: 'assets/qr-code-page-images/nfc-ios.webp',
      isLoaded: false
    },
    {
      name: 'fydl-reward-jackpot',
      url: this.url + '/assets/videos/reward/fydl-reward-jackpot.mp4',
      poster: 'assets/options-how-it-work-illustration/rewards/posters/reward-jackpot-poster.webp',
      isLoaded: false
    },
    {
      name: 'fydl-NFC-add',
      url: this.url + '/assets/videos/tag/fydl-NFC-add.mp4',
      poster: 'assets/options-how-it-work-illustration/tags/posters/tag-add.webp',
      isLoaded: false
    },
    {
      name: 'fydl-reward-NFC-android',
      url: this.url + '/assets/videos/tag/fydl-NFC-android.mp4',
      poster: 'assets/qr-code-page-images/nfc-android.webp',
      isLoaded: false
    },
    {
      name: 'fydl-reward-NFC-ios',
      url: this.url + '/assets/videos/tag/fydl-NFC-ios.mp4',
      poster: 'assets/qr-code-page-images/nfc-ios.webp',
      isLoaded: false
    },
    {
      name: 'fydl-NFC-on-off',
      url: this.url + '/assets/videos/tag/fydl-NFC-on-off.mp4',
      poster: 'assets/options-how-it-work-illustration/tags/posters/tag-on-off.webp',
      isLoaded: false
    },
    {
      name: 'fydl-sponsorship-bonus-points',
      url: this.url + '/assets/videos/sponsorship/sponsor-bonus-points.mp4',
      poster: 'assets/options-how-it-work-illustration/sponsorships/posters/sponsor-bonus-points.webp',
      isLoaded: false
    },
    {
      name: 'fydl-wheel-win',
      url: this.url + '/assets/videos/wheel-game/wheel-win.mp4',
      poster: 'assets/options-how-it-work-illustration/wheels/posters/wheel-win.webp',
      isLoaded: false
    },
  ]
  private loadedVideos: string [] = [];
  constructor(
    private platform: Platform,
    private navParams: NavParams
  ) {
    this.currentOption = this.navParams.get('inputValue') ?? {} as OptionsTypeList;
    this.setDeviceType();
  }

  private setDeviceType() {
    if (this.platform.is('android')) {
      this.isItAndroid = this.platform.is('android');

    } else if (this.platform.is('ios')) {
      this.isItIos = this.platform.is('ios');
    }
  }

  protected readonly onloadeddata = onloadeddata;

  onLoadeddata(videName: string) {
   const index = this.videos.findIndex(video => video.name === videName);
   if (index >= 0) {
     this.videos[index].isLoaded = true;
   }
  }

  getVideoByName(name: string): VideoModel {
    return this.videos.find(video => video.name === name);
  }

  isLoaded(videoName: string): boolean {
    return this.videos.find(video => video.name === videoName).isLoaded;
  }
}
